import React, { useState, useEffect, useCallback } from "react";
import { Modal, Toast, ToastContainer } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import { apiFetch } from "../../utils/apiFetch";
import AppSpinner from "../Spinner/AppSpinner";
import { unwrapArrayPayload } from "../../utils/teacherApi";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import CopyFooter from "../CopyFooter/CopyFooter";

const styles = `
  .gsm-table { width: 100%; border-collapse: collapse; font-size: 12px; color: #374151; }
  .gsm-table thead tr { background: #f3f4f6; position: sticky; top: 0; z-index: 5; }
  .gsm-table th {
    padding: 8px 10px; text-align: left; border-bottom: 1px solid #e5e7eb;
    font-weight: 700; font-size: 11px; text-transform: uppercase; white-space: nowrap;
  }
  .gsm-table tbody tr { border-bottom: 1px solid #e5e7eb; }
  .gsm-table tbody tr:hover { background: #f9fafb; }
  .gsm-table td { padding: 6px 10px; vertical-align: middle; }

  .gsm-score-input {
    width: 68px; padding: 4px 6px; border: 1px solid #d1d5db;
    border-radius: 5px; font-size: 12px; text-align: center;
  }
  .gsm-score-input:focus { outline: none; border-color: #6366f1; box-shadow: 0 0 0 2px rgba(99,102,241,0.1); }
  .gsm-score-input:disabled { background: #f3f4f6; color: #6b7280; cursor: not-allowed; }

  .gsm-cert { display: inline-block; padding: 2px 10px; border-radius: 10px; font-size: 12px; font-weight: 700; }
  .gsm-cert-a    { background: #dcfce7; color: #166534; }
  .gsm-cert-b    { background: #dbeafe; color: #1d4ed8; }
  .gsm-cert-c    { background: #fef3c7; color: #92400e; }
  .gsm-cert-f    { background: #fee2e2; color: #b91c1c; }
  .gsm-cert-none { background: #f3f4f6; color: #9ca3af; }

  .gsm-status { display: inline-block; padding: 2px 8px; border-radius: 10px; font-size: 11px; font-weight: 700; white-space: nowrap; }
  .gsm-status-pending  { background: #fef9c3; color: #92400e; }
  .gsm-status-approved { background: #dcfce7; color: #166534; }
  .gsm-status-rejected { background: #fee2e2; color: #b91c1c; }
  .gsm-status-none     { background: #f3f4f6; color: #9ca3af; }

  .gsm-btn {
    display: inline-flex; align-items: center; gap: 3px;
    border: none; border-radius: 5px; padding: 4px 10px;
    cursor: pointer; font-size: 11px; font-weight: 600; transition: background 0.15s;
    white-space: nowrap;
  }
  .gsm-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .gsm-btn-approve { background: #22c55e; color: #fff; }
  .gsm-btn-approve:hover:not(:disabled) { background: #16a34a; }
  .gsm-btn-reject  { background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca; }
  .gsm-btn-reject:hover:not(:disabled)  { background: #fecaca; }
  .gsm-btn-grade   { background: #6366f1; color: #fff; }
  .gsm-btn-grade:hover:not(:disabled)   { background: #4f46e5; }

  .gsm-reject-box {
    margin-top: 4px; display: flex; flex-direction: column; gap: 4px;
    background: #fff7f7; border: 1px solid #fecaca;
    border-radius: 5px; padding: 6px 8px; min-width: 200px;
  }
  .gsm-reject-textarea {
    width: 100%; font-size: 12px; border: 1px solid #fecaca;
    border-radius: 4px; padding: 4px 6px; resize: vertical; min-height: 50px;
    outline: none;
  }
  .gsm-comment {
    font-size: 11px; color: #b91c1c; font-style: italic;
    background: #fff7f7; border: 1px solid #fecaca;
    border-radius: 4px; padding: 4px 8px; max-width: 200px;
    white-space: normal; word-break: break-word;
  }

  .gsm-not-submitted { color: #9ca3af; font-style: italic; font-size: 11px; }
  @keyframes gsm-spin { to { transform: rotate(360deg); } }
  .gsm-spin { animation: gsm-spin 0.7s linear infinite; display: inline-block; }

  .gsm-dialog { max-width: 98vw !important; width: 98vw !important; margin: 1vh auto !important; }
  .gsm-dialog .modal-content { height: 96vh; display: flex; flex-direction: column; overflow: hidden; position: relative; }
  .gsm-dim-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.45); z-index: 10; border-radius: inherit; pointer-events: none; transition: opacity 0.2s; }
  .modal-content { position: relative; }
  .gsm-dialog .modal-body { flex: 1; display: flex; flex-direction: column; min-height: 0; overflow: hidden; padding: 16px 20px; }
  .gsm-table-wrapper { flex: 1; display: flex; flex-direction: column; min-height: 0; background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,0.08); border-radius: 4px; overflow: hidden; }
  .gsm-table-scroll { flex: 1; overflow-x: auto; overflow-y: auto; min-height: 0; }
  .gsm-table-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
  .gsm-table-scroll::-webkit-scrollbar-track { background: #f3f4f6; border-radius: 4px; }
  .gsm-table-scroll::-webkit-scrollbar-thumb { background: #93c5fd; border-radius: 4px; }
  .gsm-table-scroll::-webkit-scrollbar-thumb:hover { background: #60a5fa; }

  @media (max-width: 767px) {
    .gsm-dialog { margin: 0 !important; width: 100vw !important; max-width: 100vw !important; }
    .gsm-dialog .modal-content { height: 100dvh; border-radius: 0; }
    .modal-dialog { margin: 0.25rem !important; }
  }

  .gsm-score-cell {
    display: inline-block; min-width: 36px; padding: 2px 8px;
    border-radius: 10px; font-size: 11px; font-weight: 700; text-align: center;
  }
  .gsm-score-empty { background: #f3f4f6; color: #9ca3af; }
  .gsm-score-low   { background: #fee2e2; color: #b91c1c; }
  .gsm-score-mid   { background: #fef3c7; color: #92400e; }
  .gsm-score-high  { background: #dcfce7; color: #166534; }

  .gsm-info-bar {
    display: flex; gap: 16px; flex-wrap: wrap;
    background: #f8fafc; border: 1px solid #e5e7eb;
    border-radius: 6px; padding: 10px 14px; margin-bottom: 12px; font-size: 12px;
  }
  .gsm-info-item { display: flex; flex-direction: column; gap: 1px; }
  .gsm-info-label { font-size: 10px; text-transform: uppercase; color: #9ca3af; font-weight: 700; }
  .gsm-info-value { font-weight: 600; color: #374151; }

  .sm-section { background: #f8fafc; border: 1px solid #e5e7eb; border-radius: 8px; padding: 16px; margin-bottom: 12px; }
  .sm-section:last-child { margin-bottom: 0; }
  .sm-section-title { font-size: 11px; font-weight: 700; text-transform: uppercase; color: #9ca3af; letter-spacing: 0.05em; margin-bottom: 12px; }
  .sm-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
  .sm-field { display: flex; flex-direction: column; gap: 4px; }
  .sm-label { font-size: 11px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: 0.03em; }
  .sm-hint { font-size: 10px; color: #9ca3af; margin-top: 1px; }
  .sm-input {
    width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 6px;
    font-size: 13px; color: #374151; background: #fff; outline: none; text-align: center;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .sm-input:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,0.1); }
  .sm-input:disabled { background: #f3f4f6; color: #6b7280; cursor: not-allowed; }
  .sm-btn-cancel {
    padding: 7px 18px; border-radius: 6px; border: 1px solid #d1d5db;
    background: #fff; color: #374151; font-size: 12px; font-weight: 600; cursor: pointer;
  }
  .sm-btn-cancel:hover { background: #f3f4f6; }
  .sm-btn-cancel:disabled { opacity: 0.5; cursor: not-allowed; }
  .sm-btn-save {
    padding: 7px 22px; border-radius: 6px; border: none;
    background: #22c55e; color: #fff; font-size: 12px; font-weight: 600; cursor: pointer;
    display: inline-flex; align-items: center; gap: 6px;
  }
  .sm-btn-save:hover { background: #16a34a; }
  .sm-btn-save:disabled { background: #86efac; cursor: not-allowed; }

  .gsm-btn-excel {
    display: inline-flex; align-items: center; gap: 5px;
    background: #217346; color: #fff; border: none;
    border-radius: 6px; padding: 5px 12px; cursor: pointer;
    font-size: 12px; font-weight: 500; transition: background 0.15s; white-space: nowrap;
  }
  .gsm-btn-excel:hover:not(:disabled) { background: #1a5c38; }
  .gsm-btn-excel:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const STATUS_LABELS = {
  new: { label: "Yeni", cls: "gsm-status-none" },
  pending: { label: "Gözləyir", cls: "gsm-status-pending" },
  approved: { label: "Qəbul edilib", cls: "gsm-status-approved" },
  rejected: { label: "Qəbul edilmədi", cls: "gsm-status-rejected" },
};

const formatDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return isNaN(d) ? String(v) : d.toLocaleString("az-AZ", { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });
};

const formatDate = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  return isNaN(d) ? String(v) : d.toLocaleDateString("az-AZ");
};


const ScoreCell = ({ value }) => {
  if (value === null || value === undefined || value === "") {
    return <span className="gsm-score-cell gsm-score-empty">—</span>;
  }
  const n = Number(value);
  if (Number.isNaN(n)) return <span className="gsm-score-cell gsm-score-empty">—</span>;
  let cls = "gsm-score-low";
  if (n >= 80) cls = "gsm-score-high";
  else if (n >= 50) cls = "gsm-score-mid";
  return <span className={`gsm-score-cell ${cls}`}>{n}</span>;
};

const calcAvg = (row) => {
  const vals = [row.timeScore, row.teacherScore, row.accuracyScore, row.algorithmScore]
    .filter(v => v !== null && v !== undefined && v !== "")
    .map(Number)
    .filter(n => !Number.isNaN(n));
  return vals.length > 0 ? Math.round(vals.reduce((a, b) => a + b, 0) / vals.length) : null;
};

const getCert = (avg) => {
  if (avg === null || avg === undefined) return null;
  if (avg >= 91) return { label: "A", cls: "gsm-cert-a" };
  if (avg >= 81) return { label: "B", cls: "gsm-cert-b" };
  if (avg >= 71) return { label: "C", cls: "gsm-cert-c" };
  return { label: "F", cls: "gsm-cert-f" };
};

const NotesModal = ({ show, title, text, student, onHide }) => (
  <Modal show={show} onHide={onHide} centered size="sm">
    <Modal.Header closeButton style={{ background: "#f8fafc", borderBottom: "1px solid #e5e7eb", padding: "14px 20px" }}>
      <div>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{title}</div>
        {student && <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>{student}</div>}
      </div>
    </Modal.Header>
    <Modal.Body style={{ padding: "20px" }}>
      {text ? (
        <p style={{ fontSize: 13, color: "#374151", lineHeight: 1.7, whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0 }}>
          {text}
        </p>
      ) : (
        <p style={{ fontSize: 12, color: "#9ca3af", fontStyle: "italic", margin: 0 }}>Qeyd əlavə edilməyib</p>
      )}
    </Modal.Body>
  </Modal>
);


const SubmissionRow = ({ row, onRefresh, onScoreOpen, onHistoryOpen, onCopy, onNotesOpen, isFinished }) => {
  const status = String(row.status ?? "").toLowerCase();
  const statusInfo = STATUS_LABELS[status] ?? { label: row.status ?? "—", cls: "gsm-status-none" };
  const isPending  = status === "pending";
  const isRejected = status === "rejected";
  const canApprove = isPending || isRejected;
  const canReject  = isPending;
  const [rejectNote, setRejectNote] = useState("");
  const [showReject, setShowReject] = useState(false);
  const [busy,       setBusy]       = useState(false);
  const [showApproveConfirm, setShowApproveConfirm] = useState(false);

  const handleApprove = async () => {
    setBusy(true);
    try {
      const res = await apiFetch(`${BASE_URL}/teacher-group-projects/approve-student-project`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ teacherNotes: "", submitId: Number(row.id) }),
      });
      if (res.ok) {
        setShowApproveConfirm(false);
        onRefresh?.("Təqdimat təsdiqləndi");
      }
    } catch (e) { console.error(e); }
    finally { setBusy(false); }
  };

  const handleReject = async () => {
    const value = rejectNote.trim();
    if (value.length < 20 || value.length > 1000) return;
    setBusy(true);
    try {
      const res = await apiFetch(`${BASE_URL}/teacher-group-projects/reject-student-project`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ teacherNotes: value, submitId: Number(row.id) }),
      });
      if (res.ok) { setShowReject(false); setRejectNote(""); onRefresh?.("Təqdimat rədd edildi"); }
    } catch (e) { console.error(e); }
    finally { setBusy(false); }
  };

  return (
    <>
      <tr>
        <td onClick={() => onCopy?.(String(row.id ?? ""))} style={{ cursor: "pointer" }}>{row.id}</td>
        <td onClick={() => onCopy?.(String(row.contractId ?? ""))} style={{ cursor: "pointer" }}>{row.contractId ?? "—"}</td>
        <td onClick={() => onCopy?.(String(row.studentId ?? ""))} style={{ cursor: "pointer" }}>{row.studentId ?? "—"}</td>
        <td onClick={() => onCopy?.(row.student ?? "")} style={{ cursor: "pointer" }}><strong>{row.student ?? "—"}</strong></td>
        <td><span className={`gsm-status ${statusInfo.cls}`}>{statusInfo.label}</span></td>
        <td>
          {row.fileUrl
            ? <a href={row.fileUrl} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: "#6366f1", fontWeight: 600, textDecoration: "none" }}><i className="bi bi-box-arrow-up-right" /> Aç</a>
            : <span className="gsm-not-submitted">Yoxdur</span>}
        </td>
        <td>
          <button
            className="gsm-btn"
            style={{ background: row.studentNotes ? "#eff6ff" : "#f3f4f6", color: row.studentNotes ? "#1d4ed8" : "#9ca3af" }}
            onClick={() => onNotesOpen?.({ title: "Tələbə qeydi", text: row.studentNotes, student: row.student })}
          >
            {row.studentNotes ? "Bax" : "Yoxdur"}
          </button>
        </td>
        <td>
          <button
            className="gsm-btn"
            style={{ background: row.teacherNotes ? "#fef3c7" : "#f3f4f6", color: row.teacherNotes ? "#92400e" : "#9ca3af" }}
            onClick={() => onNotesOpen?.({ title: "Müəllim qeydi", text: row.teacherNotes, student: row.student })}
          >
            {row.teacherNotes ? "Bax" : "Yoxdur"}
          </button>
        </td>
        <td><ScoreCell value={row.timeScore} /></td>
        <td><ScoreCell value={row.teacherScore} /></td>
        <td><ScoreCell value={row.accuracyScore} /></td>
        <td><ScoreCell value={row.algorithmScore} /></td>
        <td><ScoreCell value={calcAvg(row)} /></td>
        <td>
          {(() => { const c = getCert(calcAvg(row)); return c ? <span className={`gsm-cert ${c.cls}`}>{c.label}</span> : <span className="gsm-cert gsm-cert-none">—</span>; })()}
        </td>
        <td>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <div style={{ display: "flex", gap: 4 }}>
              {!isFinished && (
                <>
                  <button
                    className="gsm-btn gsm-btn-approve"
                    onClick={() => setShowApproveConfirm(true)}
                    disabled={busy || !canApprove}
                    title={!canApprove ? "Yalnız gözləyən və ya qəbul edilməyən təqdimatları qəbul etmək olar" : ""}
                  >
                    <i className="bi bi-check-lg" /> Qəbul et
                  </button>
                  <button
                    className="gsm-btn gsm-btn-reject"
                    onClick={() => setShowReject(r => !r)}
                    disabled={busy || !canReject}
                    title={!canReject ? "Yalnız gözləyən təqdimatları rədd etmək olar" : ""}
                  >
                    <i className="bi bi-x-lg" /> Rədd et
                  </button>
                  <button className="gsm-btn gsm-btn-grade" onClick={() => onScoreOpen(row)} disabled={busy}>
                    Qiymətləri təyin et
                  </button>
                </>
              )}
              <button className="gsm-btn" style={{ background: "#0ea5e9", color: "#fff" }} onClick={() => onHistoryOpen(row)}>
                Tarixçə
              </button>
            </div>
            {!isFinished && showReject && canReject && (
              <div className="gsm-reject-box">
                <textarea
                  className="gsm-reject-textarea"
                  placeholder="Minimum 20 simvol"
                  value={rejectNote}
                  onChange={e => setRejectNote(e.target.value)}
                />
                <button className="gsm-btn gsm-btn-reject" onClick={handleReject} disabled={busy || rejectNote.trim().length < 20 || rejectNote.trim().length > 1000}>
                  {busy ? <AppSpinner inline /> : "Rəddi göndər"}
                </button>
              </div>
            )}
          </div>
        </td>
      </tr>

      <ConfirmModal
        show={showApproveConfirm}
        onHide={() => !busy && setShowApproveConfirm(false)}
        onConfirm={handleApprove}
        title="Təqdimatı təsdiqləyirsiniz?"
        message={
          <>
            <strong>{row.student ?? "Tələbə"}</strong> adlı tələbənin təqdimatını qəbul etmək istədiyinizə əminsinizmi?
          </>
        }
        confirmText="Bəli, qəbul et"
        cancelText="Ləğv et"
        variant="primary"
        loading={busy}
      />

    </>
  );
};

const ScoreModal = ({ show, target, onHide, onSaved }) => {
  const [teacherScore, setTeacherScore] = useState(80);
  const [accuracyScore, setAccuracyScore] = useState(0);
  const [algorithmScore, setAlgorithmScore] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!target) return;
    setTeacherScore(Number(target.teacherScore ?? 80));
    setAccuracyScore(Number(target.accuracyScore ?? 0));
    setAlgorithmScore(Number(target.algorithmScore ?? 0));
  }, [target]);

  const save = async () => {
    setBusy(true);
    try {
      const res = await apiFetch(`${BASE_URL}/teacher-group-projects/add-student-scores`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          submitId: Number(target.id),
          teacherScore: Number(teacherScore),
          algorithmScore: Number(algorithmScore),
          accuracyScore: Number(accuracyScore),
        }),
      });
      if (res.ok) {
        onSaved?.("Qiymətlər yadda saxlandı");
        onHide();
      }
    } catch (e) {
      console.error(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm" backdrop="static">
      <Modal.Header closeButton style={{ background: "#f3f4f6", borderBottom: "1px solid #e5e7eb", padding: "12px 20px" }}>
        <Modal.Title style={{ fontWeight: 700, color: "#374151", fontSize: 15 }}>
          Qiymətləri təyin et
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 20 }}>
        {target?.student && (
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 14, paddingBottom: 12, borderBottom: "1px solid #e5e7eb" }}>
            Tələbə: <strong style={{ color: "#374151" }}>{target.student}</strong>
          </div>
        )}
        <div className="sm-section">
          <div className="sm-section-title">Qiymətlər</div>
          <div className="sm-grid">
            <div className="sm-field">
              <label className="sm-label">Müəllim</label>
              <input type="number" className="sm-input" min={80} max={100} value={teacherScore} disabled={busy}
                onChange={e => { let v = Number(e.target.value); if (v < 80) v = 80; if (v > 100) v = 100; setTeacherScore(v); }} />
              <span className="sm-hint">80–100</span>
            </div>
            <div className="sm-field">
              <label className="sm-label">Dəqiqlik</label>
              <input type="number" className="sm-input" min={0} max={100} value={accuracyScore} disabled={busy}
                onChange={e => { let v = Number(e.target.value); if (v < 0) v = 0; if (v > 100) v = 100; setAccuracyScore(v); }} />
              <span className="sm-hint">0–100</span>
            </div>
            <div className="sm-field">
              <label className="sm-label">Alqoritm</label>
              <input type="number" className="sm-input" min={0} max={100} value={algorithmScore} disabled={busy}
                onChange={e => { let v = Number(e.target.value); if (v < 0) v = 0; if (v > 100) v = 100; setAlgorithmScore(v); }} />
              <span className="sm-hint">0–100</span>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer style={{ background: "#f3f4f6", borderTop: "1px solid #e5e7eb", padding: "10px 16px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
        <button type="button" className="sm-btn-cancel" onClick={onHide} disabled={busy}>Ləğv et</button>
        <button type="button" className="sm-btn-save" onClick={save} disabled={busy}>
          {busy ? <><AppSpinner inline /> Saxlanılır...</> : <><i className="bi bi-check-lg" /> Yadda saxla</>}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const SubmissionHistoryModal = ({ show, groupStudentProjectId, student, onHide }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notesModal, setNotesModal] = useState({ show: false, title: "", text: "" });

  const load = useCallback(async () => {
    if (!groupStudentProjectId) return;
    setLoading(true);
    try {
      const res = await apiFetch(`${BASE_URL}/teacher-group-projects/get-student-project-submits/${groupStudentProjectId}`);
      if (!res.ok) {
        setRows([]);
        return;
      }
      const data = await res.json();
      setRows(unwrapArrayPayload(data, ["list", "items", "content"]));
    } catch (e) {
      console.error(e);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [groupStudentProjectId]);

  useEffect(() => {
    if (show) load();
  }, [show, load]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      {notesModal.show && <div className="gsm-dim-overlay" />}
      <Modal.Header closeButton style={{ background: "#f8fafc", borderBottom: "1px solid #e5e7eb", padding: "14px 20px" }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>Submit tarixçəsi</div>
          {student && <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>{student}</div>}
        </div>
      </Modal.Header>
      <Modal.Body style={{ padding: "16px 20px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: "32px 0" }}>
            <AppSpinner inline />
            <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 8, marginBottom: 0 }}>Yüklənir...</p>
          </div>
        ) : rows.length === 0 ? (
          <p style={{ textAlign: "center", fontSize: 12, color: "#9ca3af", padding: "32px 0", margin: 0 }}>Məlumat tapılmadı</p>
        ) : (
          <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid #e5e7eb" }}>
            <table className="gsm-table" style={{ marginBottom: 0 }}>
              <thead>
                <tr style={{ background: "#f8fafc" }}>
                  <th>ID</th>
                  <th>Tarix</th>
                  <th>Tələbə qeydi</th>
                  <th>Müəllim qeydi</th>
                  <th>Fayl</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((item) => {
                  const st = String(item.status ?? "").toLowerCase();
                  const stInfo = STATUS_LABELS[st] ?? { label: item.status ?? "—", cls: "gsm-status-none" };
                  return (
                    <tr key={item.id}>
                      <td style={{ color: "#6b7280", fontSize: 11 }}>#{item.id}</td>
                      <td style={{ whiteSpace: "nowrap", fontSize: 11, color: "#6b7280" }}>{formatDateTime(item.register)}</td>
                      <td>
                        {item.studentNotes
                          ? <button className="gsm-btn" style={{ background: "#eff6ff", color: "#1d4ed8" }} onClick={() => setNotesModal({ show: true, title: "Tələbə qeydi", text: item.studentNotes })}>Bax</button>
                          : <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>}
                      </td>
                      <td>
                        {item.teacherNotes
                          ? <button className="gsm-btn" style={{ background: "#fef3c7", color: "#92400e" }} onClick={() => setNotesModal({ show: true, title: "Müəllim qeydi", text: item.teacherNotes })}>Bax</button>
                          : <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>}
                      </td>
                      <td>{item.fileUrl ? <a href={item.fileUrl} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: "#6366f1", fontWeight: 600 }}><i className="bi bi-box-arrow-up-right" /> Aç</a> : <span style={{ color: "#9ca3af", fontSize: 12 }}>—</span>}</td>
                      <td><span className={`gsm-status ${stInfo.cls}`}>{stInfo.label}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <NotesModal
        show={notesModal.show}
        title={notesModal.title}
        text={notesModal.text}
        onHide={() => setNotesModal({ show: false, title: "", text: "" })}
      />
    </Modal>
  );
};

const GradeSubmissionModal = ({ show, assignment, onHide }) => {
  const [rows, setRows]         = useState([]);
  const [loading, setLoading]   = useState(false);
  const [toast, setToast]       = useState({ show: false, msg: "", variant: "success" });
  const [scoreTarget, setScoreTarget] = useState(null);
  const [historyTarget, setHistoryTarget] = useState(null);
  const [notesModal, setNotesModal] = useState({ show: false, title: "", text: "", student: "" });
  const [copiedText, setCopiedText] = useState("");

  const isChildOpen = !!(scoreTarget || historyTarget || notesModal.show);

  const handleNotesOpen = ({ title, text, student }) => setNotesModal({ show: true, title, text, student });
  const handleNotesClose = () => setNotesModal({ show: false, title: "", text: "", student: "" });

  const fetchSubmissions = useCallback(async () => {
    if (!assignment?.id) return;
    setLoading(true);
    try {
      const res = await apiFetch(`${BASE_URL}/teacher-group-projects/get-group-student-submits/${assignment.id}`);
      if (!res.ok) { setRows([]); return; }
      const data = await res.json();
      setRows(unwrapArrayPayload(data, ["list", "items", "content"]));
    } catch (e) {
      console.error(e);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [assignment?.id]);

  useEffect(() => {
    if (show) fetchSubmissions();
    else setRows([]);
  }, [show, fetchSubmissions]);

  const handleRefresh = (msg) => {
    setToast({ show: true, msg, variant: "success" });
    fetchSubmissions();
  };

  const projectName  = assignment?.project ?? "—";
  const groupName    = assignment?.group ?? "—";
  const beginDate    = assignment?.beginDate;
  const dayLimit     = assignment?.dayLimit;

  const exportToExcel = async () => {
    if (rows.length === 0) return;

    const { default: ExcelJS } = await import("exceljs");
    const wb = new ExcelJS.Workbook();
    wb.creator = "DevSys";
    wb.created = new Date();

    const ws = wb.addWorksheet("Nəticələr", {
      pageSetup: { paperSize: 9, orientation: "landscape", fitToPage: true, fitToWidth: 1 },
      views: [{ state: "frozen", ySplit: 6 }],
    });

    const today = new Date().toLocaleDateString("az-AZ");
    const TOTAL_COLS = 13;

    const thin = (argb) => ({ style: "thin", color: { argb } });
    const thinBorder = { top: thin("E5E7EB"), left: thin("E5E7EB"), bottom: thin("E5E7EB"), right: thin("E5E7EB") };
    const hdrBorder  = { top: thin("5B21B6"), left: thin("7E3AF2"), bottom: thin("5B21B6"), right: thin("7E3AF2") };
    const solid = (argb) => ({ type: "pattern", pattern: "solid", fgColor: { argb } });

    ws.columns = [
      { width: 7 }, { width: 17 }, { width: 14 }, { width: 28 },
      { width: 16 }, { width: 18 }, { width: 13 },
      { width: 13 }, { width: 14 }, { width: 11 }, { width: 11 }, { width: 11 }, { width: 12 },
    ];

    const mergeRow = (r, val, bg, fg, sz, bold, italic) => {
      ws.mergeCells(r, 1, r, TOTAL_COLS);
      const c = ws.getCell(r, 1);
      c.value = val;
      c.fill = solid(bg);
      c.font = { name: "Calibri", size: sz, bold: !!bold, italic: !!italic, color: { argb: fg } };
      c.alignment = { horizontal: "center", vertical: "middle" };
    };

    ws.getRow(1).height = 34;
    mergeRow(1, "LAYIHƏ NƏTİCƏLƏRİ", "7E3AF2", "FFFFFF", 16, true);

    ws.getRow(2).height = 22;
    mergeRow(2, `Layihə: ${projectName}`, "EDE9FE", "5B21B6", 12, true);

    ws.getRow(3).height = 20;
    mergeRow(3, `Qrup: ${groupName}`, "F5F0FF", "374151", 11, false);

    ws.getRow(4).height = 18;
    mergeRow(4, `İxrac tarixi: ${today}   |   Tələbə sayı: ${rows.length}`, "F3F4F6", "6B7280", 10, false, true);

    ws.getRow(5).height = 6;

    const HEADERS = [
      "ID", "Müqavilə kodu", "Tələbə kodu", "Tələbə",
      "Verilmə tarixi", "Təhvil tarixi", "Günlər sayı",
      "Vaxt qiyməti", "Müəllim qiyməti", "Dəqiqlik", "Alqoritm", "Ortalama", "Sertifikat",
    ];
    const hRow = ws.getRow(6);
    hRow.height = 26;
    HEADERS.forEach((h, i) => {
      const c = hRow.getCell(i + 1);
      c.value = h;
      c.fill = solid("5B21B6");
      c.font = { name: "Calibri", size: 11, bold: true, color: { argb: "FFFFFF" } };
      c.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      c.border = hdrBorder;
    });

    const scoreStyle = (val) => {
      const n = Number(val);
      if (isNaN(n) || val === "" || val === null || val === undefined) return null;
      if (n >= 80) return { bg: "DCFCE7", fg: "166534" };
      if (n >= 50) return { bg: "FEF3C7", fg: "92400E" };
      return { bg: "FEE2E2", fg: "B91C1C" };
    };

    const certStyle = (label) => {
      if (label === "A") return { bg: "DCFCE7", fg: "166534" };
      if (label === "B") return { bg: "DBEAFE", fg: "1D4ED8" };
      if (label === "C") return { bg: "FEF3C7", fg: "92400E" };
      if (label === "F") return { bg: "FEE2E2", fg: "B91C1C" };
      return null;
    };

    const calcDays = (begin, register) => {
      if (!begin || !register) return null;
      const a = new Date(begin), b = new Date(register);
      if (isNaN(a) || isNaN(b)) return null;
      return Math.max(0, Math.round((b - a) / 86400000));
    };

    rows.forEach((row, idx) => {
      const eRow = ws.getRow(7 + idx);
      eRow.height = 20;
      const rowBg = idx % 2 === 0 ? "FFFFFF" : "FAF5FF";
      const avg  = calcAvg(row);
      const cert = getCert(avg);
      const days = calcDays(beginDate, row.register);
      const limit = assignment?.dayLimit ?? Infinity;

      const values = [
        row.id ?? "—",
        row.contractId ?? "—",
        row.studentId ?? "—",
        row.student ?? "—",
        formatDate(beginDate),
        row.register ? formatDateTime(row.register) : "—",
        days !== null ? days : "—",
        row.timeScore  ?? "—",
        row.teacherScore ?? "—",
        row.accuracyScore ?? "—",
        row.algorithmScore ?? "—",
        avg ?? "—",
        cert ? cert.label : "—",
      ];

      values.forEach((val, ci) => {
        const cell = eRow.getCell(ci + 1);
        cell.value = val;
        cell.fill  = solid(rowBg);
        cell.font  = { name: "Calibri", size: 10, color: { argb: "374151" } };
        cell.border = thinBorder;
        cell.alignment = { vertical: "middle", horizontal: ci >= 4 ? "center" : "left" };

        if (ci >= 7 && ci <= 11) {
          const sc = scoreStyle(val);
          if (sc) {
            cell.fill = solid(sc.bg);
            cell.font = { name: "Calibri", size: 10, bold: true, color: { argb: sc.fg } };
          }
        }

        if (ci === 12) {
          const cc = certStyle(val);
          if (cc) {
            cell.fill = solid(cc.bg);
            cell.font = { name: "Calibri", size: 11, bold: true, color: { argb: cc.fg } };
          }
          cell.alignment = { horizontal: "center", vertical: "middle" };
        }

        if (ci === 6 && days !== null) {
          const bg = days > limit ? "FEE2E2" : days > limit * 0.8 ? "FEF3C7" : "DCFCE7";
          const fg = days > limit ? "B91C1C" : days > limit * 0.8 ? "92400E" : "166534";
          cell.fill = solid(bg);
          cell.font = { name: "Calibri", size: 10, bold: true, color: { argb: fg } };
        }
      });
    });

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const safeName = (projectName ?? "layihe").replace(/[^\w\s-]/g, "").trim().replace(/\s+/g, "_").slice(0, 40);
    a.download = `${safeName}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <style>{styles}</style>

      <Modal show={show} onHide={onHide} centered size="xl" backdrop="static" dialogClassName="gsm-dialog">
        {isChildOpen && <div className="gsm-dim-overlay" />}
        <Modal.Header closeButton style={{ background: "#f3f4f6", borderBottom: "1px solid #e5e7eb", padding: "12px 20px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flex: 1, marginRight: 8 }}>
            <span style={{ fontWeight: 700, color: "#374151", fontSize: "15px" }}>Təqdimatlar — {projectName}</span>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <button
                className="gsm-btn-excel"
                onClick={exportToExcel}
                disabled={loading || rows.length === 0}
                title="Excel-ə ixrac et"
              >
                <i className="bi bi-file-earmark-spreadsheet" /> Excel
              </button>
              <button
                onClick={fetchSubmissions}
                disabled={loading}
                title="Yenilə"
                style={{ background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1, flexShrink: 0 }}
              >
                <i className={`bi bi-arrow-clockwise${loading ? " gsm-spin" : ""}`} style={{ fontSize: 13 }} />
              </button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="gsm-info-bar" style={{ flexShrink: 0 }}>
            <div className="gsm-info-item">
              <span className="gsm-info-label">Qrup</span>
              <span className="gsm-info-value">{groupName}</span>
            </div>
            <div className="gsm-info-item">
              <span className="gsm-info-label">Müddət</span>
              <span className="gsm-info-value">{dayLimit ?? 0} gün</span>
            </div>
            <div className="gsm-info-item">
              <span className="gsm-info-label">Verilmə tarixi</span>
              <span className="gsm-info-value">{formatDate(beginDate)}</span>
            </div>
            <div className="gsm-info-item">
              <span className="gsm-info-label">Sətir sayı</span>
              <span className="gsm-info-value">{rows.length}</span>
            </div>
          </div>

          <div className="gsm-table-wrapper">
            {loading ? (
              <div className="text-center py-5">
                <AppSpinner inline />
                <p className="text-muted small mt-2 mb-0">Yüklənir...</p>
              </div>
            ) : rows.length === 0 ? (
              <p className="text-center text-muted py-4" style={{ fontSize: 12 }}>Bu qrupda tələbə tapılmadı.</p>
            ) : (
              <div className="gsm-table-scroll">
                <table className="gsm-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Müqavilə kodu</th>
                      <th>Tələbə kodu</th>
                      <th>Tələbə</th>
                      <th>Status</th>
                      <th>Fayl linki</th>
                      <th>Tələbə qeydi</th>
                      <th>Müəllim qeydi</th>
                      <th title="Vaxt qiyməti">Vaxt</th>
                      <th title="Müəllim qiyməti">Müəllim</th>
                      <th title="Dəqiqlik qiyməti">Dəqiqlik</th>
                      <th title="Alqoritm qiyməti">Alqoritm</th>
                      <th title="Ortalama bal">Ortalama</th>
                      <th title="Sertifikat">Sertifikat</th>
                      <th>Əməliyyat</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, i) => (
                      <SubmissionRow
                        key={row.id ?? row.studentId ?? i}
                        row={row}
                        onRefresh={handleRefresh}
                        onScoreOpen={setScoreTarget}
                        onHistoryOpen={setHistoryTarget}
                        onCopy={setCopiedText}
                        onNotesOpen={handleNotesOpen}
                        isFinished={assignment?.status === "Bitdi"}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <CopyFooter value={copiedText} />
          </div>
        </Modal.Body>

      </Modal>

      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 100000 }}>
        <Toast bg={toast.variant} show={toast.show} onClose={() => setToast(t => ({ ...t, show: false }))} delay={2000} autohide>
          <Toast.Header closeButton><strong className="me-auto">Uğurlu</strong></Toast.Header>
          <Toast.Body className="text-white">{toast.msg}</Toast.Body>
        </Toast>
      </ToastContainer>

      <ScoreModal
        show={!!scoreTarget}
        target={scoreTarget}
        onHide={() => setScoreTarget(null)}
        onSaved={handleRefresh}
      />
      <SubmissionHistoryModal
        show={!!historyTarget}
        groupStudentProjectId={historyTarget?.id}
        student={historyTarget?.student}
        onHide={() => setHistoryTarget(null)}
      />
      <NotesModal
        show={notesModal.show}
        title={notesModal.title}
        text={notesModal.text}
        student={notesModal.student}
        onHide={handleNotesClose}
      />
    </>
  );
};

export default GradeSubmissionModal;
